export const saveUserToLocal = async (user) => {
  const userData = {
    uid: user.uid,
    name: user.displayName || '',
    email: user.email || '',
    photoURL: user.photoURL || '',
    token: await user.getIdToken(),
  };

  localStorage.setItem('token', JSON.stringify(userData.token));
  localStorage.setItem('user', JSON.stringify(userData));
  localStorage.setItem('userID', JSON.stringify(userData.uid));
  localStorage.setItem('auth', 'true');

  return userData;
};

export const clearUserFromLocal = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userID');
  localStorage.removeItem('auth');
};

export const getAuthFlag = () => {
  return localStorage.getItem('auth') === 'true';
};